import { apiGet, apiPost, apiPut, apiDelete } from "./client";
import type { FolderTreeResponse, Folder, ModelMeta, Model } from "../types";

export function getModels(): Promise<FolderTreeResponse> {
  return apiGet<FolderTreeResponse>("/folder");
}

export function getModel(id: number): Promise<Model> {
  return apiGet<Model>(`/model/${id}`);
}

export function createModel(
  name: string,
  folderId: number,
): Promise<ModelMeta> {
  return apiPost<ModelMeta>("/model", { name, folder_id: folderId });
}

export function updateModel(
  id: number,
  name: string,
  folderId: number,
): Promise<ModelMeta> {
  return apiPut<ModelMeta>(`/model/${id}`, { name, folder_id: folderId });
}

export function deleteModel(id: number): Promise<void> {
  return apiDelete<void>(`/model/${id}`);
}

export function createFolder(
  name: string,
  parentId: number,
): Promise<Folder> {
  return apiPost<Folder>("/folder", { name, folder_id: parentId });
}

export function updateFolder(
  id: number,
  name: string,
  parentId: number,
): Promise<Folder> {
  return apiPut<Folder>(`/folder/${id}`, { name, folder_id: parentId });
}

export function deleteFolder(id: number): Promise<void> {
  return apiDelete<void>(`/folder/${id}`);
}

export function moveSharedModel(
  id: number,
  folderId: number,
): Promise<number> {
  return apiPut<number>(`/shared_model/${id}`, { folder_id: folderId });
}
